import { render, staticRenderFns } from "./OptimizationWizard.vue?vue&type=template&id=b32f4e1c&scoped=true"
import script from "./OptimizationWizard.vue?vue&type=script&lang=js"
export * from "./OptimizationWizard.vue?vue&type=script&lang=js"
import style0 from "./OptimizationWizard.vue?vue&type=style&index=0&id=b32f4e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f4e1c",
  null
  
)

export default component.exports